import {
  message,
  PageHeader,
  Spin,
  Select,
  //Form as FormInitial,
  Row,
  Col,
  Tooltip,
  Space,
  Alert,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  InputItem,
  ButtonItem,
  ErrorItem,
  SelectInsumosItem,
  DynamicCardForm,
  TabbedDynamicTable,
  ModalItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
} from "../../../../Components/Items";
import { PlusOutlined, DeleteOutlined, ContainerOutlined, LockOutlined } from "@ant-design/icons";
import ElegirMarbetes from "../../Marbetes/ElegirMarbetes/ElegirMarbetes";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";

const { Option } = Select;

class EditarOrdenProductosAlCosto extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    todasInsumos: [],
    objetoInsumos: null,
    modalAgregarCuentaContable: false,
    modalElegirMarbetes: false,
    modalElegirMarbetesMarbetes: [],
    modalElegirMarbetesInsumoId: null,
    modalElegirMarbetesProyectoId: null,
    estadoOrden: null,
    cantidadInsumosOriginales: 0,
    indicesApartados: [],
    modalConfirmarEdicionConfirmada: false,
    valoresPendientes: null,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "productosAlCosto/datosOrdenProductosAlCosto",
        {
          empresaId: this.props.empresaId,
          ordenId: this.props.location.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then(async (res) => {
        if (res.data.status === 404) {
          return;
        }
        if (res.data.estado === 0) {
          message.warning("Esta orden está cancelada y no se puede editar");
          this.atras();
          return;
        }
        this.setState({
          todasInsumos: res.data.insumosCatalogo || [],
          estadoOrden: res.data.estado,
          cantidadInsumosOriginales: (res.data.insumos || []).length,
          // Posiciones con inventario ya reservado: quedan congeladas hasta
          // que se desaparten (el backend rechaza cualquier cambio en ellas).
          indicesApartados: (res.data.insumos || [])
            .map((insumo, index) => (Number(insumo.apartado || 0) > 0 ? index : -1))
            .filter((index) => index !== -1),
        });

        let insumosConCantidad = res.data.insumos;
        if (res.data.insumos.length > 0) {
          const insumosBulkPayload = res.data.insumos.map((insumo, index) => ({
            index,
            insumoId: insumo.insumoId,
            proyectoId: res.data.proyectoId,
            inventariable: true,
          }));
          try {
            const resInventarios = await axios.post(
              "inventarios/inventarioInsumoProyectoBulk",
              {
                empresaId: this.props.empresaId,
                proyectoId: res.data.proyectoId,
                insumos: insumosBulkPayload,
              },
              { headers: this.props.headersToken }
            );
            insumosConCantidad = res.data.insumos.map((insumo, index) => {
              const resultado = resInventarios.data?.results?.find((r) => r.index === index);
              return { ...insumo, cantidadProyecto: resultado?.cantidad ?? 0 };
            });
          } catch (error) {
            console.error("Error al consultar inventario", error);
          }
        }

        await this.formRef.current.setFieldsValue({
          proyectoId: res.data.proyectoId,
          referencia: res.data.referencia,
          insumos: insumosConCantidad,
        });
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (!values.insumos || values.insumos?.length === 0)
      return message.warning("Agregue insumos para poder guardar la orden");

    if (this.state.estadoOrden === 3) {
      // Orden ya confirmada: mostrar antes el resumen de lo que hará el
      // sistema (agregar solo los insumos nuevos) y pedir confirmación.
      this.setState({ valoresPendientes: values, modalConfirmarEdicionConfirmada: true });
      return;
    }

    this.guardarEdicion(values);
  }
  guardarEdicion(values) {
    this.setState({ loading: true, modalConfirmarEdicionConfirmada: false });
    axios
      .post(
        "productosAlCosto/editarOrdenProductosAlCosto",
        {
          ...values,
          ordenId: this.props.location.state.id,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false, valoresPendientes: null });
        if (res.data.success === 2) {
          message.success("Se ha actualizado la orden");
          if (res.data.resumen) {
            NotificacionPolizas(res.data.resumen.polizaNueva || []);
            NotificacionMovimientosInventario(res.data.resumen.movimientoNuevo || []);
          }
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se puede guardar la orden");
        } else {
          message.error("Hubo un error y la orden no se guardo");
        }
      });
  }
  async onChangeInsumo(value, key, insumoEncontrado) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proyecto = await this.formRef.current.getFieldValue("proyectoId");
    this.setState({ loading: true });
    const insumoId = arrayValue[key].insumoId;
    let insumo
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
      if (!yaExiste) {
        await this.setState(prev => ({
          todasInsumos: [...prev.todasInsumos, insumo]
        }));
      }
    } else {
      insumo = this.state.todasInsumos.find(
        (valueInsumos) => valueInsumos._id === insumoId
      );
    }
    this.setState({ loading: false });
    if (!insumo) return
    await axios
      .post(
        "inventarios/inventarioInsumoProyecto",
        {
          proyectoId: proyecto,
          insumoId: insumoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        arrayValue[key].cantidadProyecto = res.data.cantidad;
      });
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
    if (proyectoId) {
      this.setState({
        modalElegirMarbetes: true,
        modalElegirMarbetesIndex: value,
        modalElegirMarbetesMarbetes: marbetes || [],
        modalElegirMarbetesInsumoId: insumoId,
        modalElegirMarbetesProyectoId: proyectoId
      })
    } else {
      message.warning('Elegir un proyecto para elegir marbetes')
    }
  }

  cerrarElegirMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirMarbetesIndex].marbetes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirMarbetes: false,
      modalElegirMarbetesIndex: null,
      modalElegirMarbetesMarbetes: null,
      modalElegirMarbetesInsumoId: null,
      modalElegirMarbetesProyectoId: null
    })
  }

  abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirLotes: true,
        modalElegirLotesIndex: value,
        modalElegirLotesLotes: lotes || [],
        modalElegirLotesInsumoId: insumoId,
        modalElegirLotesProyectoId: proyectoId,
        modalElegirLotesClienteId: clienteId,
        modalElegirLotesCantidad: cantidad
      })
    } else {
      message.warning('Elegir un proyecto para elegir lotes')
    }
  }
  cerrarElegirLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirLotesIndex].lotes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirLotes: false,
      modalElegirLotesIndex: null,
      modalElegirLotesLotes: null,
      modalElegirLotesInsumoId: null,
      modalElegirLotesProyectoId: null,
      modalElegirLotesClienteId: null,
      modalElegirLotesCantidad: null
    })
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    const allTabs = [
      {
        key: 'insumos',
        label: 'Insumos',
        listName: 'insumos',
        columns: [
          { title: 'Clave', width: '6%' },
          { title: 'Insumo', width: '38%' },
          { title: 'Unidad', width: '6%' },
          { title: 'Cantidad Proyecto', width: '15%' },
          { title: 'Cantidad', width: '15%' },
          { title: 'Acción', width: '15%' },
        ],

        renderRow: ({ key, name, restField, arrayKey, remove }) => (
          <FormItem key={key} noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const row = (getFieldValue('insumos') || [])[arrayKey];
              const lotes = row?.lotes || [];
              const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
              const necesitaLotes = insumo?.lotesCaducidades;
              const cantidad = row?.cantidad || 0;
              const sumLotes = lotes.reduce((s, l) => s + (l.cantidadRequerida || 0), 0);
              const isRed = necesitaLotes && cantidad > 0 && sumLotes !== cantidad;
              // Una vez confirmada la orden, los renglones que ya se dieron
              // de baja quedan congelados: solo se pueden agregar renglones
              // nuevos (los que se agreguen después de este punto).
              // Un renglón con inventario apartado también queda congelado:
              // su reserva ya vive en EntradaSalida, hay que desapartarlo
              // antes de poder cambiarlo o eliminarlo.
              const esRenglonApartado = this.state.indicesApartados.includes(arrayKey);
              const esRenglonCongelado =
                (this.state.estadoOrden === 3 && arrayKey < this.state.cantidadInsumosOriginales) ||
                esRenglonApartado;
              return (
            <tr style={isRed ? { backgroundColor: '#ffccc7' } : {}}>
              <td className="td-border">
                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                    const insumoSeleccionado = this.state.todasInsumos?.find(
                      (insumo) => insumo._id.toString() === insumoId?.toString()
                    );
                    return (
                      <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                        {insumoSeleccionado?.clave || '-'}
                      </div>
                    );
                  }}
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem
                  {...restField}
                  name={[name, "insumoId"]}
                  fieldKey={[arrayKey, "insumoId"]}
                  required
                  noStyle
                >
                  <SelectInsumosItem
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    sinBorde
                    autoFocus
                    ocultarCodigoYUnidad
                    dropdownMatchSelectWidth={600}
                    width="100%"
                    placeholder="Insumo"
                    tiposInsumos="inventariables"
                    disabled={esRenglonCongelado}
                    onChange={(value, insumoEncontrado) =>
                      this.onChangeInsumo(value, arrayKey, insumoEncontrado)
                    }
                    insumoPreCargado={insumo}
                  />
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                    const insumoSeleccionado = this.state.todasInsumos?.find(
                      (insumo) => insumo._id.toString() === insumoId?.toString()
                    );
                    return (
                      <div style={{ fontSize: '14px', textAlign: 'center' }}>
                        {insumoSeleccionado?.unidad || '-'}
                      </div>
                    );
                  }}
                </FormItem>
              </td>

              <td className="td-border">
                <FormItem
                  {...restField}
                  name={[name, "cantidadProyecto"]}
                  fieldKey={[arrayKey, "cantidadProyecto"]}
                  number
                  noStyle
                  required
                  initialValue={undefined}
                >
                  <InputNumberItem sinBorde disabled />
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem
                  noStyle
                  shouldUpdate={(prev, curr) =>
                    prev.insumos[arrayKey]?.cantidadProyecto !==
                    curr.insumos[arrayKey]?.cantidadProyecto
                  }
                >
                  {({ getFieldValue }) => {
                    const insumos = getFieldValue("insumos");
                    if (!insumos[arrayKey]) return
                    const cantidadProyecto =
                      insumos[arrayKey].cantidadProyecto;
                    // Un renglón congelado (ya confirmado o ya apartado) sacó
                    // su inventario del disponible, así que `cantidadProyecto`
                    // ya no lo incluye: aplicar el tope lo dejaría en error
                    // permanente sin poder corregirlo.
                    let max = esRenglonCongelado ? undefined : cantidadProyecto;
                    return (
                      <FormItem
                        {...restField}
                        name={[name, "cantidad"]}
                        fieldKey={[arrayKey, "cantidad"]}
                        number
                        noStyle
                        required
                        max={max}
                        type='number'
                        initialValue={undefined}
                      >
                        <InputNumberItem sinBorde disabled={esRenglonCongelado} />
                      </FormItem>
                    );
                  }}
                </FormItem>
              </td>
              <td className="td-border-sin-right">
                <Row className="acciones-container">
                  <Col span={24}>
                    <Space
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                      size={0}
                      className="acciones-container"
                    >
                      <Space size={0}>
                        <FormItem noStyle shouldUpdate>
                          {({ getFieldValue }) => {
                            if (esRenglonCongelado) return null;
                            const arrayValue = getFieldValue("insumos") || [];
                            const proyectoId = getFieldValue("proyectoId");

                            let buttons = [];
                            let mostrarMarbetes = false;
                            let mostrarLotes = false;
                            let insumoId;

                            if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                              const insumo = this.state.todasInsumos.find(
                                (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                              );

                              mostrarMarbetes = insumo?.marbetes;
                              mostrarLotes = insumo?.lotesCaducidades;
                              insumoId = insumo?._id;
                            }
                            if (mostrarMarbetes) {
                              buttons.push(
                                <ButtonItem
                                  type="primary"
                                  size="small"
                                  style={{ width: "80%", marginLeft: "10%" }}
                                  block
                                  onClick={() =>
                                    this.abrirElegirMarbetes(
                                      arrayKey,
                                      arrayValue[arrayKey].marbetes,
                                      insumoId,
                                      proyectoId
                                    )
                                  }
                                >
                                  Mar.
                                </ButtonItem>
                              );
                            } else if (mostrarLotes) {
                              buttons.push(
                                <Tooltip title={this.props.taxidermia ? "Animales" : "Lotes"} placement="top" overlayInnerStyle={{fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                  <ButtonItem
                                    type="primary"
                                    size='small'
                                    amarillo2
                                    icon={<ContainerOutlined />}
                                    onClick={() => {
                                      this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].cantidad)
                                    }}
                                  >
                                  </ButtonItem>
                                </Tooltip>
                              );
                            }
                            return buttons;
                          }}
                        </FormItem>
                      </Space>
                      {esRenglonApartado &&
                        <Tooltip title="Este renglón tiene inventario apartado. Desapártalo desde la orden para poder editarlo o eliminarlo." placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                          <LockOutlined style={{ color: '#a66d02' }} />
                        </Tooltip>
                      }
                      {!esRenglonCongelado &&
                        <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                          <ButtonItem rojo2 icon={<DeleteOutlined />} onClick={() => remove(name)} size="small" lessTime />
                        </Tooltip>
                      }
                    </Space>
                  </Col>
                </Row>
              </td>
            </tr>
              );
            }}
          </FormItem>
        ),

        renderFooter: ({ add, fields }) => (
          <FormItem
            noStyle
            shouldUpdate={(prev, curr) =>
              prev.proyectoId !== curr.proyectoId
            }
          >
            {({ getFieldValue }) => {
              const proyecto = getFieldValue("proyectoId");
              return (
                <FormItem noStyle>
                  <div style={{ marginBottom: 6, marginTop: 6 }}>
                    <ButtonItem
                      type="dashed"
                      hotkey="alt+a"
                      cyan
                      block
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        justifySelf: fields.length > 0 ? "left" : null,
                        width: fields.length > 0 ? "auto" : null,
                      }}
                      onClick={
                          proyecto
                          ? () => add()
                          : () =>
                            message.info(
                              "Agregue el proyecto primero"
                            )
                      }
                      icon={<PlusOutlined />}
                    >
                      Agregar Campo
                    </ButtonItem>
                  </div>
                </FormItem>
              );
            }}
          </FormItem>
        ),
      },
    ];
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Editar Orden - Productos al costo"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        {this.state.estadoOrden === 3 &&
          <Alert
            style={{ marginBottom: 12 }}
            type="warning"
            showIcon
            message="Esta orden ya fue confirmada"
            description="Los insumos que ya se dieron de baja quedan congelados: no se pueden editar ni eliminar. Solo puedes agregar insumos nuevos, que generarán una póliza y un movimiento de inventario adicionales. Hazlo con cuidado."
          />
        }
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="productosAlCosto"
              layout
              bottom={
                <div className="general-form-action-buttons">
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    hotkey="shift+a"
                    cyanB
                  >
                    Guardar
                  </ButtonItem>
                </div>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
          <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
            <Col xs={24} lg={24} xl={24}>
              <DynamicCardForm
                title="DATOS GENERALES"
                style={{ margin: 0, height: '100%' }}
              >
                <Row gutter={[12, 12]}>
                  <Col xs={24} lg={12}>
                    <FormItem shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const insumos = getFieldValue('insumos')
                        const disabled = insumos?.length > 0
                        return (
                          <FormItem label="Proyecto" name="proyectoId" margin required>
                            <SelectItem placeholder="Proyecto" disabled={disabled}>
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                        )
                      }}
                    </FormItem>
                  </Col>
                  <Col xs={24} lg={12}>
                    <FormItem
                      name="referencia"
                      label="Referencia"
                      margin
                      pattern
                    >
                      <InputItem placeholder="Referencia" />
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>
            </Col>
          </Row>
               <div style={{ marginTop: 40 }}>
                <TabbedDynamicTable
                  formInstance={this.formRef}
                  defaultActiveKey="insumos"
                  isMobile={isMobile}
                  tabs={allTabs}
                />
               </div>
            </Form>
          </Spin>
        </div>
        <ElegirMarbetes
          visible={this.state.modalElegirMarbetes}
          cerrarElegirMarbetes={this.cerrarElegirMarbetes.bind(this)}
          marbetes={this.state.modalElegirMarbetesMarbetes}
          insumoId={this.state.modalElegirMarbetesInsumoId}
          proyectoId={this.state.modalElegirMarbetesProyectoId}
        />
        <ElegirLotes
          visible={this.state.modalElegirLotes}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
          lotes={this.state.modalElegirLotesLotes}
          insumoId={this.state.modalElegirLotesInsumoId}
          proyectoId={this.state.modalElegirLotesProyectoId}
          clienteId={this.state.modalElegirLotesClienteId}
          cantidad={this.state.modalElegirLotesCantidad}
        />
        <ModalItem
          title="Confirmar edición de orden ya confirmada"
          visible={this.state.modalConfirmarEdicionConfirmada}
          onCancel={() => this.setState({ modalConfirmarEdicionConfirmada: false, valoresPendientes: null })}
          onOk={() => this.guardarEdicion(this.state.valoresPendientes)}
          spinning={false}
          footer
        >
          <p>Al guardar estos cambios el sistema:</p>
          <ul>
            <li>No tocará los insumos que ya se dieron de baja — quedan tal cual.</li>
            <li>Descontará del inventario únicamente los insumos nuevos que agregaste.</li>
            <li>Generará una póliza y un movimiento de inventario adicionales, solo con esos insumos nuevos.</li>
          </ul>
          <p style={{ textAlign: 'center', fontWeight: 'bold' }}>¿Seguro que quieres continuar?</p>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarOrdenProductosAlCosto);
